import { render } from "./BasicUsage.vue?vue&type=template&id=f6c65d5e"
import script from "./BasicUsage.vue?vue&type=script&lang=js"
export * from "./BasicUsage.vue?vue&type=script&lang=js"

import "./BasicUsage.vue?vue&type=style&index=0&id=f6c65d5e&lang=css"
script.render = render

export default script